import {__} from "./__";

export const getAiAgentNames = () => {
    return {
        'ChangeOrderState': __('Manažér stavov objednávok'),
        'EshopReport': __('Reportér eshopu'),
    };
};
